import { useNPContext } from '../../../npContext';

export const useBasketCount = (): number => {
    let context = useNPContext();

    return context?.state?.centra?.selection?.totals && context.state.centra.selection.totals
        ? context.state.centra.selection.totals.totalQuantity
        : 0;
};
